import { MetricKpiCard } from "@/features/dashboard/shell";
import { OverviewSection } from "@/features/dashboard/hub/OverviewSection";

import {
  MOCK_EMAIL_SENT_TODAY,
  MOCK_EMAIL_SPARK,
  MOCK_WHATSAPP_SENT_TODAY,
  MOCK_WHATSAPP_SPARK,
} from "./mock-data";

/**
 * Overview mock de notificaciones del día.
 */
export function NotificationsOverview(): React.JSX.Element {
  return (
    <OverviewSection
      title="Notificaciones"
      description="Envíos de hoy (WhatsApp y email)"
      isMock
    >
      <div className="grid grid-cols-2 gap-3">
        <MetricKpiCard
          label="WhatsApp hoy"
          value={MOCK_WHATSAPP_SENT_TODAY}
          hint="Mensajes enviados en el día (mock)"
          sparkline={MOCK_WHATSAPP_SPARK}
        />
        <MetricKpiCard
          label="Email hoy"
          value={MOCK_EMAIL_SENT_TODAY}
          hint="Correos enviados en el día (mock)"
          sparkline={MOCK_EMAIL_SPARK}
        />
      </div>
    </OverviewSection>
  );
}
